import { RelodeApiError, SuccessAction } from "@relode/core";
import {
    ActionsUnion,
    createAction,
    createMetaAction,
} from "@relode/core/components/reducer/actionHelpers";
import {
    CandidateDetails,
    CandidateShareDetails,
} from "../../../../shared/types";

enum names {
    LOAD_CANDIDATE = "LOAD_CANDIDATE",
    LOAD_CANDIDATE_SUCCESS = "LOAD_CANDIDATE_SUCCESS",
    LOAD_CANDIDATE_FAILURE = "LOAD_CANDIDATE_FAILURE",
    LOAD_CANDIDATE_SHARE = "LOAD_CANDIDATE_SHARE",
    LOAD_CANDIDATE_SHARE_SUCCESS = "LOAD_CANDIDATE_SHARE_SUCCESS",
    LOAD_CANDIDATE_SHARE_FAILURE = "LOAD_CANDIDATE_SHARE_FAILURE",
    MANAGE_CANDIDATE_FEEDBACK = "MANAGE_CANDIDATE_FEEDBACK",
    MANAGE_CANDIDATE_FEEDBACK_SUCCESS = "MANAGE_CANDIDATE_FEEDBACK_SUCCESS",
    MANAGE_CANDIDATE_FEEDBACK_FAILURE = "MANAGE_CANDIDATE_FEEDBACK_FAILURE",
}

export default names;

export const creators = {
    loadCandidate: () => createAction(names.LOAD_CANDIDATE),
    loadCandidateSuccess: (
        jobId: number,
        leadId: number,
        candidate: CandidateDetails
    ) =>
        createAction(names.LOAD_CANDIDATE_SUCCESS, {
            jobId,
            leadId,
            candidate,
        }),
    loadCandidateFailure: (apiError: RelodeApiError) =>
        createAction(names.LOAD_CANDIDATE_FAILURE, { apiError }),
    loadCandidateShare: () => createAction(names.LOAD_CANDIDATE_SHARE),
    loadCandidateShareSuccess: (candidateShare: CandidateShareDetails) =>
        createAction(names.LOAD_CANDIDATE_SHARE_SUCCESS, {
            candidateShare,
        }),
    loadCandidateShareFailure: (apiError: RelodeApiError) =>
        createAction(names.LOAD_CANDIDATE_SHARE_FAILURE, { apiError }),

    manageCandidateFeedback: () =>
        createAction(names.MANAGE_CANDIDATE_FEEDBACK),
    manageCandidateFeedbackSuccess: (message: string) =>
        createMetaAction(
            names.MANAGE_CANDIDATE_FEEDBACK_SUCCESS,
            new SuccessAction(message),
            { message }
        ),
    manageCandidateFeedbackFailure: (apiError: RelodeApiError) =>
        createAction(names.MANAGE_CANDIDATE_FEEDBACK_FAILURE, { apiError }),
};

export type CandidateActionTypes = ActionsUnion<typeof creators>;
